import React from 'react';
import Reporting from '../../Reporting';

const ReportSettingsTabContent = () => {
  return (
    <Reporting isGroupReporting />
  )
};

export default ReportSettingsTabContent;